interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    pages.push(i);
  }

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md px-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          aria-current={page === current ? 'page' : undefined}
          className={`h-9 w-9 cursor-pointer rounded-md text-sm font-medium transition-colors ${
            page === current
              ? 'bg-primary-500 text-background-50'
              : 'text-foreground-700 hover:bg-background-100'
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md px-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}